import React from "react";
import { AiFillFacebook, AiFillTwitterSquare } from "react-icons/ai";

const ShareButtons = () => {
  return (
    <div>
      <div className="mt-4 flex items-center space-x-1 text-4xl">
        <AiFillFacebook className="text-blue-600 cursor-pointer" />
        <AiFillTwitterSquare className="text-blue-300 cursor-pointer" />
      </div>
    </div>
  );
};

export default ShareButtons;
